<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4 class="mr-auto">{{ $t("PACKAGE_DEAL") }}</h4>
    </div>
    <div class="grid-body border-top-unset">
      <div class="body-room-sale">
        <div class="grid pb-0">
          <div class="grid-body">
            <v-progress-linear
              color="secondary"
              indeterminate
              rounded
              height="3"
              v-if="isLoading"
            ></v-progress-linear>

            <v-card-text>
              <v-row align="center">
                <v-col sm="3" class="pt-0 pb-0">
                  <treeselect :multiple="true" :options="listRoomTypeByRoomCategory" :placeholder="$t('ALL_ROOM')" :limit="1"
                @close="change()" @open="open()" :limitText="fnCount" v-model="selectedRoom" />
                </v-col>
              </v-row>
            </v-card-text>
            <div class="view-table">
              <div class="max-height-table" :style="{ 'max-height': maxHeight + 'px' }" @scroll="loadData">
                <table class="room-sale-table" v-if="isLoading == false">
                  <tr>
                    <td class="table-left">
                      <div class="table-left-content">
                        <table>
                          <thead>
                            <tr>
                              <th colspan="2">
                                <div class="header-wrapper calendar">
                                  <v-icon
                                    light
                                    left
                                    color="#003e94"
                                    size="40"
                                    @click="prevMonth()"
                                    >chevron_left
                                  </v-icon>
                                  <date-picker
                                    :model.sync="selectedDatePicker"
                                    :min="currentDatePicker"
                                    :max="maxDate"
                                    format="DD/MM/YYY"
                                    class="outlined"
                                    dense
                                    outlined
                                  />
                                  <v-icon
                                    light
                                    right
                                    color="#003e94"
                                    size="40"
                                    @click="nextMonth()"
                                    >chevron_right
                                  </v-icon>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="relationData">
                            <template v-for="(room, i) in tmpRelationData">
                              <template v-for="(ratePlan, j1) in room.ratePlans">
                                <tr :key="`room_${i}_ratePlan_${j1}`">
                                  <td class="room-row">
                                    <div
                                      class="body-wrapper fs-10"
                                    >
                                      <div class="vertical-divider">
                                        <div>
                                         <p class="text-truncate mb-0 fs-12" style="max-width: 200px" :title=" room.roomTypeI18n.find((x) => x.lang == defaultI18n).name + ' - ' + ratePlan.i18ns.find(
                                                (x) => x.lang == defaultI18n
                                              ).name">
                                          {{ room.roomTypeI18n.find((x) => x.lang == defaultI18n).name }} - {{
                                              ratePlan.i18ns.find(
                                                (x) => x.lang == defaultI18n
                                              ).name
                                            }}
                                         </p>
                                          <div
                                            class="flex"
                                            v-if="ratePlan.roomRates.length > 0"
                                          >
                                            <div>
                                              <v-icon
                                                light
                                                right
                                                size="16"
                                                color="#003e94"
                                                >groups</v-icon
                                              >
                                              <span>
                                                x
                                                {{
                                                  ratePlan.roomRates[0].guestsIncluded
                                                }}</span
                                              >
                                            </div>
                                            <div>
                                              <v-icon
                                                light
                                                right
                                                size="16"
                                                color="#003e94"
                                                >man</v-icon
                                              >
                                              <span>
                                                x
                                                {{
                                                  ratePlan.roomRates[0].adultsIncluded
                                                }}</span
                                              >
                                            </div>
                                            <div>
                                              <v-icon
                                                light
                                                right
                                                size="12"
                                                color="#003e94"
                                                >emoji_people</v-icon
                                              >
                                              <span>
                                                x
                                                {{
                                                  ratePlan.roomRates[0].childrenIncluded
                                                }}</span
                                              >
                                            </div>
                                            <div>
                                              <v-icon
                                                light
                                                right
                                                size="16"
                                                color="#003e94"
                                                >child_care</v-icon
                                              >
                                              <span>
                                                x
                                                {{
                                                  ratePlan.roomRates[0].babiesIncluded
                                                }}</span
                                              >
                                            </div>
                                          </div>
                                        </div>
                                        <div>
                                          <v-icon
                                            v-if="
                                              listRoomRatePackage.filter(
                                                (sv) =>
                                                  sv.roomRateId ===
                                                  ratePlan.roomRates[0].id
                                              ).length > 0
                                            "
                                            light
                                            right
                                            size="17"
                                            color="#003e94"
                                            @click="
                                              editServiceRoomRate(ratePlan.roomRates[0])
                                            "
                                            >edit</v-icon
                                          >
                                          <v-icon
                                            light
                                            right
                                            size="17"
                                            color="#003e94"
                                            @click="
                                              addServiceRoomRate(ratePlan.roomRates[0])
                                            "
                                            >add_circle</v-icon
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="room-row">
                                    <div class="body-wrapper">
                                      <div class="vertical-divider">
                                        <span>
                                          {{ $t("PRICE") }}  ({{ currency }})
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <template v-for="(sv, s) in listRoomRatePackage">
                                  <tr 
                                    v-if="sv.roomRateId === ratePlan.roomRates[0].id" 
                                    :key="`room_${i}_ratePlan_${j1}_listRoomRatePackage_${s}`"
                                  >
                                    <td>
                                      <div
                                        class="body-wrapper"
                                        :style="{
                                          height: '100%',
                                          fontSize: '12px',
                                        }"
                                      >
                                        <div class="vertical-divider">
                                          <div
                                            class="pl-3 text-truncate mr-auto"
                                            style="max-width: 200px"
                                          >
                                            {{
                                              sv.serviceStaticMinimalDTO.serviceStaticI18ns.find(
                                                (x) => x.lang == defaultI18n
                                              ).name
                                            }}
                                          </div>
                                          <div>(x {{ sv.nos }})</div>
                                          <div>
                                            <v-icon
                                              light
                                              right
                                              size="17"
                                              color="red"
                                              @click="
                                                $refs.deleteDialogComponent.open(sv)
                                              "
                                              >delete</v-icon
                                            >
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div class="body-wrapper">
                                        <div class="vertical-divider">
                                          <span>
                                            {{ $t("PRICE") }} ({{ sv.percent ? "%" : currency }})
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </template>
                              </template>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </td>
                    <td class="table-right">
                      <div id="ngonquadi" class="table-right-content">
                        <table>
                          <thead>
                            <tr>
                              <th 
                                v-for="(item, i) in dateList" 
                                :class="{ 'weekend-header': item.isWeekend }" 
                                :key="`dateList_${i}`"
                              >
                                <div class="header-wrapper">
                                  <div
                                    class="date"
                                    v-html="formatDate(item.date)"
                                  ></div>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="relationData">
                            <template v-for="(room, i) in tmpRelationData">
                              <template v-for="(ratePlan, j1) in room.ratePlans">
                                <tr :key="`room_right_${i}_ratePlan_${j1}`">
                                  <td class="room-row"
                                    v-for="(avail, index) in dateList"
                                    :class="{ 'weekend-body': avail.isWeekend }"
                                    :key="`room_right_${i}_ratePlan_${j1}_dateList_${index}`"
                                  >
                                    <div
                                      class="body-wrapper special-price"
                                      v-if="
                                        ratePlan.roomRates.length > 0 &&
                                        ratePlan.roomRates[0]['roomRateSpecials'].length >
                                          0 &&
                                        ratePlan.roomRates[0]['roomRateSpecials'].filter(
                                          (x) => x.appliedDate == avail.date
                                        ).length > 0 &&
                                        ratePlan.roomRates[0]['roomRateSpecials'].find(
                                          (x) => x.appliedDate == avail.date
                                        ).pricePax != -1
                                      "
                                    >
                                      <div
                                        :class="
                                          ratePlan.restrictions[index].closed
                                            ? 'vertical-divider closed'
                                            : 'vertical-divider'
                                        "
                                      >
                                        <div
                                          v-if="
                                            ratePlan.restrictions[index].closedOnArrival
                                          "
                                          class="before"
                                        ></div>
                                        <span>
                                          <span
                                            class="cursor"
                                            >{{
                                              numberFormat(
                                                ratePlan.roomRates[0][
                                                  "roomRateSpecials"
                                                ].find((x) => x.appliedDate == avail.date)
                                                  .pricePax
                                              )
                                            }}</span
                                          >
                                        </span>
                                        <div
                                          v-if="
                                            ratePlan.restrictions[index].closedOnDeparture
                                          "
                                          class="after"
                                        ></div>
                                      </div>
                                    </div>

                                    <div
                                      v-else-if="ratePlan.roomRates.length > 0"
                                      class="body-wrapper"
                                    >
                                      <div
                                        :class="
                                          ratePlan.restrictions[index].closed
                                            ? 'vertical-divider closed'
                                            : 'vertical-divider'
                                        "
                                      >
                                        <div
                                          v-if="
                                            ratePlan.restrictions[index].closedOnArrival
                                          "
                                          class="before"
                                        ></div>
                                        <span
                                          style="font-weight: bold"
                                          class="cursor"
                                        >
                                          {{
                                            numberFormat(
                                              ratePlan.roomRates[0][
                                                formatDateOfWeekInPrice(avail.date)
                                              ]
                                            )
                                          }}
                                        </span>
                                        <div
                                          v-if="
                                            ratePlan.restrictions[index].closedOnDeparture
                                          "
                                          class="after"
                                        ></div>
                                      </div>
                                    </div>
                                  </td>
                                  <td></td>
                                </tr>
                                <template v-for="(sv, s) in listRoomRatePackage">
                                  <tr 
                                    v-if="sv.roomRateId === ratePlan.roomRates[0].id"
                                    :key="`room_right_${i}_ratePlan_${j1}_listRoomRatePackage_${s}`"
                                  >
                                    <td
                                      v-for="(avail, index) in dateList"
                                      :class="{ 'weekend-body': avail.isWeekend }"
                                      :key="`room_right_${i}_ratePlan_${j1}_listRoomRatePackage_${s}_dateList_${index}`"
                                    >
                                      <div class="body-wrapper">
                                        <div class="vertical-divider">
                                          <span
                                            style="font-weight: bold"
                                            v-if="
                                              listRoomRatePackageSpecial.length > 0 &&
                                              listRoomRatePackageSpecial.find(
                                                (e) =>
                                                  e.appliedDate === avail.date &&
                                                  e.roomRateId === sv.roomRateId &&
                                                  e.serviceStaticId === sv.serviceStaticId
                                              )
                                            "
                                          >
                                            {{
                                              listRoomRatePackageSpecial.find(
                                                (e) =>
                                                  e.appliedDate === avail.date &&
                                                  e.roomRateId === sv.roomRateId &&
                                                  e.serviceStaticId === sv.serviceStaticId
                                              ).price === 0
                                                ? 0
                                                : numberFormat(
                                                    listRoomRatePackageSpecial.find(
                                                      (e) =>
                                                        e.appliedDate === avail.date &&
                                                        e.roomRateId === sv.roomRateId &&
                                                        e.serviceStaticId ===
                                                          sv.serviceStaticId
                                                    ).price
                                                  )
                                            }}
                                          </span>
                                          <span v-else>
                                            {{
                                              sv[
                                                formatDateOfWeekInPriceService(avail.date)
                                              ] === 0
                                                ? 0
                                                : numberFormat(
                                                    sv[
                                                      formatDateOfWeekInPriceService(
                                                        avail.date
                                                      )
                                                    ]
                                                  )
                                            }}
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                    <td></td>
                                  </tr>
                                </template>
                              </template>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </table>
                <div v-if="loadingMore" class="text-center py-2" style="position:sticky; left: 0;">
                  <v-progress-circular
                    :width="2"
                    color="gray"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </div>
              <v-col class="border-top">
                  <ul class="tools-icon-description">
                    <li>
                      <v-icon light size="17" color="#003e94" class="pr-1"
                        >add_circle</v-icon
                      >
                      {{ $t("ADD_SERVICE_TO_ROOM_RATE") }}
                    </li>
                    <li>
                      <v-icon light right size="17" color="red" class="pr-1"
                        >delete</v-icon
                      >
                      {{ $t("DELETE") }}
                    </li>
                    <li>
                      <v-icon light size="17" color="#003e94" class="pr-1">edit</v-icon>
                      {{ $t("EDIT_ATTRIBUTION") }}
                    </li>
                    <li>
                      <span class="i-square orange"></span>
                      {{ $t("closed") }}
                    </li>
                    <li>
                      <span class="i-square">
                        <i class="close-before"></i>
                      </span>
                      {{ $t("closedOnArrival") }}
                    </li>
                    <li>
                      <span class="i-square">
                        <i class="close-after"></i>
                      </span>
                      {{ $t("closedOnDeparture") }}
                    </li>
                  </ul>
              </v-col>
            </div>
          </div>
        </div>

        <!-- Popup xac nhan xoa goi ban -->
        <delete-dialog
          @deleteItem="removeServiceRoomRate"
          :maxWidth="325"
          ref="deleteDialogComponent"
        >
          <span slot="title">{{ $t("CONFIRM_DELETE_SERVICE_PACKAGE") }}?</span>
        </delete-dialog>
        <!-- popup add service -->
        <v-dialog
          v-model="openDialogAddService"
          width="750"
          class="modal-quick-edit"
          id="dialog-add-service"
        >
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong> {{ $t("ADD_SERVICE_TO_ROOM_RATE") }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update content-update-service">
            <v-text-field
              :label="$t('_BOOKING.SEARCH')"
              :placeholder="$t('SERVICE.NAME')"
              outlined
              dense
              v-model="search"
              @input="searchOnList"
              class="w-50"
            ></v-text-field>
            <b-form-group>
              <v-row class="pb-4 mt-3">
                <template v-if="searched.length > 0">
                  <v-col 
                    md="6" 
                    class="pb-0" 
                    v-for="(item, key) in searched" 
                    :key="`searched_${key}`"
                  >
                    <div class="d-flex">
                      <div class="mr-auto">
                        <b-form-checkbox
                          v-model="modelAddService"
                          :key="item.id"
                          :value="item.id"
                          name="flavour-3a"
                          :disabled="item.active"
                          inline
                        >
                          {{ item.name }}
                        </b-form-checkbox>
                        <!-- <v-checkbox
                        v-model="modelAddService"
                        :label="item.name"
                        :value="item.id"
                        class="p-0 m-0"
                        :disabled="item.active"
                      ></v-checkbox> -->
                      </div>
                      <div class="spinbutton-add-service">
                        <b-form-spinbutton
                          id="demo-sb"
                          v-model="item.nos"
                          min="1"
                          max="100"
                        ></b-form-spinbutton>
                      </div>
                    </div>
                  </v-col>
                </template>
                <template v-else>
                  <v-col md="12" class="text-center" style="color: red">{{
                    $t("REQUEST_EMPTY")
                  }}</v-col>
                </template>
              </v-row>
            </b-form-group>
            <div class="mt-4 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn depressed block @click="openDialogAddService = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn block color="primary" @click="confirmAddService()">
                  {{ $t("SAVE") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.name).includes(toLower(term)));
  }

  return items;
};
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import { _alert } from "@/_helpers/function.js";
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { serviceCombo } from "@/_services/Combo/Combo.service.js";
import DatePicker from "@/components/Utils/DatePicker.vue";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { syncota } from "@/_services/SyncOTA/syncota.js";

import moment from "moment";
import { categoryService } from "@/_services/SaleRoom/category.service.js";

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: {
    "delete-dialog": DeleteDialog,
    "date-picker": DatePicker,
    Treeselect
  },
  data() {
    return {
      currency: this.usedCurrency,
      maxHeight: 430,
      weekend: ["WED", "THU", "FRI", "SAT", "SUN", "TUE", "MON"],
      defaultWeekend: [],
      dateList: [],
      listWeekend: [],
      isLoading: true,
      systemLang: this.$i18n.locale,
      currentDatePicker: moment().startOf("day").format("YYYY-MM-DD"),
      selectedRoom: [], // Phòng đang được sửa
      listRoom: [], // Danh sách các phòng, do dữ liệu roomData cấu thành list
      relationData: [], // Thông tin gói bán và giá của tất cả phòng do API trả về
      currentDate: moment().startOf("day").toDate(),
      maxDate: moment(this.currentDate)
        .add(2, "year")
        .add(14, "day")
        .format("YYYY-MM-DD"),
      listOTA: [],
      selectedOTA: "EZ_BE",
      selectedDatePicker: moment().startOf("day").format("YYYY-MM-DD"),
      currentYear: new Date().getFullYear(),
      roomAvai: 0,
      roomIdUpdate: null,
      roomUpdate: null,
      rateUpdate: null,

      //
      listService: [],
      listRoomRatePackage: [],
      openDialogAddService: false,
      roomRateIdAdd: null,
      listServiceStaticMap: [],
      modelAddService: [],
      search: null,
      searched: [],
      listRoomRatePackageSpecial: [],
      listRateCategory: [],
      selectedRateCategory: [],
      listRatePlanByRateCategory: [],
      changeSelect: false,
      isOpen: false,
      listRoomTypeByRoomCategory: [],
      listRoomCategory: [],
      perPage: 0,
      totalPage: 0,
      tmpRelationData: [],
      loadingRelation: false,
      loadingMore: false,
      itemsPerPage: 10,
      quantityRequest: 10,
      controller: null,
    };
  },
  computed: {
    daysOfMonths() {
      return [31, this.isLeapYear() ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    },
  },
  created() {
    this.maxHeight = window.innerHeight - 60 - 68 - 46 - 16 - 75;
    this.initialize();
  },
  watch: {
    selectedDatePicker() {
      this.currentDate = this.selectedDatePicker;
      this.getData();
    },
    selectedRoom() {
      if (this.selectedRoom.length === 0 && this.isOpen === false) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.changeSearchCondition(true);
        }, 1000);
        this.changeSelect = false;
      } else {
        this.changeSelect = true;
      }
    },
  },
  mounted() {},
  methods: {
    loadData(event) {
      if (this.loadingMore) {
        return;
      }

      const table = event.target;
      const scrollTop = table.scrollTop;
      const clientHeight = table.clientHeight;
      const scrollHeight = table.scrollHeight;
      if (this.perPage == this.totalPage && this.loadingRelation) {
        this.loadingMore = true;
        return;
      }

      if (scrollHeight - scrollTop - clientHeight <= 100 && this.perPage < this.totalPage) {
        this.loadingMore = true;
        setTimeout(() => {
          this.tmpRelationData = [...this.tmpRelationData, ...this.relationData.slice(this.perPage * this.itemsPerPage, (this.perPage + 1) * this.itemsPerPage)];
          this.perPage += 1;
          this.loadingMore = false;
        }, 1000);
      }
    },
    caculatorApi(roomTypeIds) {
      const totalApi = Math.ceil(roomTypeIds.length / this.quantityRequest);
      let itemChunk = [];
      for(let i = 0; i < totalApi; i++) {
        itemChunk.push(roomTypeIds.slice(i * this.quantityRequest, (i + 1) * this.quantityRequest));
      }
      return  itemChunk;
    },
    change() {
      if (this.changeSelect === true) {
        this.changeSearchCondition(true);
        this.changeSelect = false;
      }
      this.isOpen = false;

    },
    open() {
      this.isOpen = true;
    },
    searchOnList() {
      this.searched = [...searchByName(this.listServiceStaticMap, this.search)];
    },
    addServiceRoomRate(roomRate) {
      this.openDialogAddService = true;
      this.roomRateIdAdd = roomRate.id;
      this.listServiceStaticMap = this.listService.map((e) =>
        Object.assign(
          {},
          {
            id: e.id,
            nos: 1,
            active: false,
            name: e.serviceStaticI18ns.find((x) => x.lang == this.defaultI18n).name,
            priceMonday: 0,
            priceTuesday: 0,
            priceWednesday: 0,
            priceThursday: 0,
            priceFriday: 0,
            priceSaturday: 0,
            priceSunday: 0,
            percent: e.percent,
            packageId: null,
          }
        )
      );
      const arr = this.listRoomRatePackage.filter((e) => e.roomRateId === roomRate.id);
      if (arr.length > 0) {
        arr.forEach((e) => {
          this.listServiceStaticMap.forEach((se) => {
            if (se.id === e.serviceStaticId) {
              se.nos = e.nos;
              se.active = true;
              se.percent = e.percent;
              se.priceMonday = +e.priceMonday;
              se.priceTuesday = +e.priceTuesday;
              se.priceWednesday = +e.priceWednesday;
              se.priceThursday = +e.priceThursday;
              se.priceFriday = +e.priceFriday;
              se.priceSaturday = +e.priceSaturday;
              se.priceSunday = +e.priceSunday;
              se.packageId = e.id;
            }
          });
        });
      }
      this.modelAddService = [];
      this.listServiceStaticMap.forEach((e) => {
        if (e.active) {
          this.modelAddService.push(e.id);
        }
      });
      this.search = null;
      this.searched = this.listServiceStaticMap;
    },
    confirmAddService() {
      if (this.modelAddService.length > 0) {
        const arr = this.listServiceStaticMap.filter((e) =>
          this.modelAddService.includes(e.id)
        );
        const isPercent = this.listServiceStaticMap.find((e) => e.active)
          ? this.listServiceStaticMap.find((e) => e.active).percent
          : false;
        const body = arr.map((e) =>
          Object.assign(
            {},
            {
              id: e.packageId,
              action: !e.active ? 1 : 2,
              serviceStaticId: e.id,
              nos: e.nos,
              roomRateId: this.roomRateIdAdd,
              priceMonday: e.priceMonday,
              priceTuesday: e.priceTuesday,
              priceWednesday: e.priceWednesday,
              priceThursday: e.priceThursday,
              priceFriday: e.priceFriday,
              priceSaturday: e.priceSaturday,
              priceSunday: e.priceSunday,
              percent: isPercent,
              status: true,
            }
          )
        );
        this.openDialogAddService = false;
        if (body.length > 0) {
          serviceCombo.updateRoomRatePackageList(body).then((res) => {
            _alert(res, this.$t(res.data), false);
            this.getData();
          });
        }
      }
    },
    removeServiceRoomRate(service) {
      serviceCombo.removeServiceRoomRate(service.id).then((res) => {
        _alert(res, this.$t(res.data), false);
        if (res.responseCode === 0) {
          this.getData();
        }
      });
    },
    async getListServiceStatic() {
      return await serviceCombo.getAllService().then(res => res.data);
    },
    async getRoomRatePackage() {
      return await serviceCombo.getRoomRatePackage().then(res => res.data);
    },
    async getRoomRatePackageSpecial() {
      return await serviceCombo.getRoomRatePackageSpecial().then(res => res.data);
    },
    isLeapYear() {
      return (
        this.currentYear % 400 === 0 ||
        (this.currentYear % 100 !== 0 && this.currentYear % 4 === 0)
      );
    },
    onResize() {
      this.maxHeight = window.innerHeight - 60 - 68 - 46 - 16 - 70;
    },
    formatDateOfWeekInPrice(date) {
      let dayOfWeek;
      switch (moment(date).day()) {
        case 0: {
          dayOfWeek = "paxSunday";
          break;
        }
        case 1: {
          dayOfWeek = "paxMonday";
          break;
        }
        case 2: {
          dayOfWeek = "paxTuesday";
          break;
        }
        case 3: {
          dayOfWeek = "paxWednesday";
          break;
        }
        case 4: {
          dayOfWeek = "paxThursday";
          break;
        }
        case 5: {
          dayOfWeek = "paxFriday";
          break;
        }
        case 6: {
          dayOfWeek = "paxSaturday";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDateOfWeekInPriceService(date) {
      let dayOfWeek;
      switch (moment(date).day()) {
        case 0: {
          dayOfWeek = "priceSunday";
          break;
        }
        case 1: {
          dayOfWeek = "priceMonday";
          break;
        }
        case 2: {
          dayOfWeek = "priceTuesday";
          break;
        }
        case 3: {
          dayOfWeek = "priceWednesday";
          break;
        }
        case 4: {
          dayOfWeek = "priceThursday";
          break;
        }
        case 5: {
          dayOfWeek = "priceFriday";
          break;
        }
        case 6: {
          dayOfWeek = "priceSaturday";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDateOfWeek(date) {
      let dayOfWeek;
      switch (date.day()) {
        case 0: {
          dayOfWeek = "SUN";
          break;
        }
        case 1: {
          dayOfWeek = "MON";
          break;
        }
        case 2: {
          dayOfWeek = "TUE";
          break;
        }
        case 3: {
          dayOfWeek = "WED";
          break;
        }
        case 4: {
          dayOfWeek = "THU";
          break;
        }
        case 5: {
          dayOfWeek = "FRI";
          break;
        }
        case 6: {
          dayOfWeek = "SAT";
          break;
        }
      }
      return dayOfWeek;
    },
    formatDate(date) {
      const currentDate = moment(date, "YYYY-MM-DD");
      if (!currentDate.isValid()) {
        return "";
      }
      let dayOfWeek = "";
      switch (currentDate.day()) {
        case 0: {
          dayOfWeek = this.$t("SUN_SHORT").toString();
          break;
        }
        case 1: {
          dayOfWeek = this.$t("MON_SHORT").toString();
          break;
        }
        case 2: {
          dayOfWeek = this.$t("TUE_SHORT").toString();
          break;
        }
        case 3: {
          dayOfWeek = this.$t("WED_SHORT").toString();
          break;
        }
        case 4: {
          dayOfWeek = this.$t("THU_SHORT").toString();
          break;
        }
        case 5: {
          dayOfWeek = this.$t("FRI_SHORT").toString();
          break;
        }
        case 6: {
          dayOfWeek = this.$t("SAT_SHORT").toString();
          break;
        }
      }
      return (
        '<div class="day-week">' +
        dayOfWeek +
        '</div><div class="day-day">' +
        currentDate.format("DD") +
        '</div><div class="day-month">' +
        this.$t(currentDate.format("MMM").toUpperCase() + "_SHORT") +
        "</div>"
      );
    },
    loadDateList() {
      let hotelWeekend = JSON.parse(localStorage.getItem("hotelWeekend"));
      // Chuyển từ binary sang select
      this.defaultWeekend = this.convertFromBinaryToListSelection(hotelWeekend);
      var tmp = [];
      this.defaultWeekend.forEach(function (element, index) {
        if (element == 1) {
          if (index == 0) {
            tmp.push("MON");
          }
          if (index == 1) {
            tmp.push("TUE");
          }
          if (index == 2) {
            tmp.push("WED");
          }
          if (index == 3) {
            tmp.push("THU");
          }
          if (index == 4) {
            tmp.push("FRI");
          }
          if (index == 5) {
            tmp.push("SAT");
          }
          if (index == 6) {
            tmp.push("SUN");
          }
        }
      });
      const currentDate = moment(this.currentDate);
      this.dateList = [];
      for (let i = 0; i < 15; i++) {
        const isWeekend = tmp.indexOf(currentDate.format("ddd").toUpperCase()) > -1;
        this.dateList.push({
          date: currentDate.format("YYYY-MM-DD"),
          isWeekend: isWeekend,
        });
        currentDate.add(1, "day");
      }
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    async initialize() {
      this.isLoading = true;
      this.currency = this.usedCurrency;
      await this.getAllRelationApi();
    },
    getAllRelationApi() {
      Promise.all([
        this.getAllOTA(),
        this.getAllRateCategory(),
        this.getAllPlanByRateCategory(),
        this.getAllRoomByRoomCategory(),
        this.getListServiceStatic(),
        this.getRoomRatePackage(),
        this.getRoomRatePackageSpecial()
      ]).then(([
        otaList,
        listRateCategory,
        listPlanByRateCategory,
        listRoomByRoomCategory,
        listServiceStatic,
        roomRatePackage,
        roomRatePackageSpecial
      ]) => {
        this.listOTA = otaList.map((x) => {
          return {
            value: x.id,
            text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
            date: this.inDays(new Date(), new Date(x.endDate)),
            endDate: moment(x.endDate).format("DD/MM/YYYY HH:mm"),
            otaCode: x.otaCode,
          };
        });
        this.listOTA = this.listOTA.filter((x) => x.value);
        this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
        if (!this.listOTA.find((x) => x.otaCode == "EZ_BE")) {
          this.selectedOTA = this.listOTA[0].value;
        } else {
          this.selectedOTA = this.listOTA.find((x) => x.otaCode == "EZ_BE").value;
        }

        this.listRateCategory = listRateCategory.map(x => x.id);

        const data = [];
        if (listPlanByRateCategory.length > 0) {
          listPlanByRateCategory.forEach(e => {
            if (e.ratePlans.length > 0) {
              data.push({
                id: e.rateCategoryId ? e.rateCategoryId : -1,
                label: e.rateCategoryI18ns.find(l => l.lang === this.defaultI18n).name,
                children: e.ratePlans.map(pl => Object.assign({}, {
                  id: pl.id,
                  label: pl.ratePlanI18n.find(l => l.lang === this.defaultI18n).name,
                }))
              })
            }
          });
          this.listRatePlanByRateCategory = [...data];
          this.selectedSalePackage = this.listRatePlanByRateCategory.map(e => e.id);
        }

        if (listRoomByRoomCategory.length > 0) {
          const dataListRoomByRoomCategory = [];
          this.listRoomCategory = listRoomByRoomCategory.map(x => x.roomCategoryId);
          listRoomByRoomCategory.forEach(e => {
            if (e.roomTypes.length > 0) {
              dataListRoomByRoomCategory.push({
                id: e.roomCategoryId ? e.roomCategoryId : -1,
                label: e.roomCategoryI18ns.find(l => l.lang === this.defaultI18n) ? e.roomCategoryI18ns.find(l => l.lang === this.defaultI18n).name : e.nameVi,
                children: e.roomTypes.map(pl => Object.assign({}, {
                  id: pl.id,
                  label: pl.roomTypeI18n.find(l => l.lang === this.defaultI18n) ? pl.roomTypeI18n.find(l => l.lang === this.defaultI18n).name : pl.nameVi,
                }))
              })
            }
          })
          this.listRoomTypeByRoomCategory = [...dataListRoomByRoomCategory];
          this.selectedRoom = this.listRoomTypeByRoomCategory.map(e => e.id);
        }

        this.listService = listServiceStatic.serviceStaticMinimalDTOS.filter((e) => e.status);
        this.listRoomRatePackage = roomRatePackage.roomRatePackageDTOS;
        this.listRoomRatePackageSpecial = roomRatePackageSpecial.roomRatePackageSpecialDTOS;

        this.getData();
      });
    },
    async getAllOTA() {
      return await syncota.getAllOTA({ keyword: "", status: 1 }).then(res => res.data);
    },
    async getData() {
      this.isLoading = true;
      this.loadDateList();
      var fromDate = this.selectedDatePicker;
      var toDate = moment(this.selectedDatePicker).add(15, "day").format("YYYY-MM-DD");
      var ratePlanIds = [];
      this.selectedSalePackage.forEach(e => {
        if (this.listRateCategory.includes(e) || e == -1) {
          var arrPlanIds = this.listRatePlanByRateCategory.find(item => item.id === e).children.map(c => c.id);
          ratePlanIds = ratePlanIds.concat(arrPlanIds)
        } else {
          ratePlanIds.push(e)
        }
      })
      var roomTypeIds = [];
      this.selectedRoom.forEach(e => {
        if (this.listRoomCategory.includes(e) || e == -1) {
          var arrRoomIds = this.listRoomTypeByRoomCategory.find(item => item.id === e).children.map(c => c.id);
          roomTypeIds = roomTypeIds.concat(arrRoomIds)
        } else {
          roomTypeIds.push(e)
        }
      })

      if (
        this.controller && 
        this.controller instanceof AbortController && 
        !this.controller.signal.aborted
      ) {
        this.controller.abort();
      }

      if (roomTypeIds.length == 0) {
        this.tmpRelationData = [];
        this.relationData = [];
        this.perPage = 0;
        this.isLoading = false;
        return;
      }

      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.loadingRelation = true;
      const itemChunk = this.caculatorApi(roomTypeIds);
      const bodyTemplate = {
        from: fromDate,
        to: toDate,
        ratePlanIds: ratePlanIds.length > 0 ? [...ratePlanIds] : [],
        otaId: this.selectedOTA,
        rateCategoryIds: []
      };

      this.tmpRelationData = [];
      this.relationData = [];
      this.perPage = 0;
      
      try {
        for (let i = 0; i < itemChunk.length; i++) {
          if (signal.aborted) {
            return;
          }

          if (i > 0) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
          const body = {
            ...bodyTemplate,
            roomTypeIds: itemChunk[i],
          };

          const res = await sale_room.getAllRelation(body, signal);
          if (res.responseCode == 0) {
            const data = res.data.filter(room => room.ratePlans.length > 0);
            this.relationData = [...this.relationData, ...data];
            this.totalPage = Math.ceil(this.relationData.length / this.itemsPerPage);
            
            if (this.perPage == 0) {
              this.tmpRelationData = this.relationData.slice(this.perPage * this.itemsPerPage, (this.perPage + 1) * this.itemsPerPage);
              this.perPage += 1;
              this.isLoading = false;
            }

            if (this.loadingMore) {
              setTimeout(() => {
                this.tmpRelationData = [...this.tmpRelationData, ...this.relationData.slice(this.perPage * this.itemsPerPage, (this.perPage + 1) * this.itemsPerPage)];
                this.perPage += 1;
                this.loadingMore = false;
              }, 1000);
            }
          }
          this.loadingRelation = i != itemChunk.length - 1;
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          this.isLoading = false;
          _alert({}, this.$t('ERROR'), false);
        }
      }
    },
    async getAllPlanByRateCategory() {
      return await sale_room.getAllRatePlanByCategory().then(res => res.data);
    },
    async getAllRoomByRoomCategory() {
      return await sale_room.getAllRoomTypeByCategory().then(res => res.data);
    },
    async getAllRateCategory() {
      let body = {};
      body.keyword = "";
      body.status = 1;
      body.limit = 99999;
      body.offset = 0;
      body.orderBy = 'ativee';
      body.asc = false;
      return await categoryService.getRateCategoryList(body).then(res => res.data);
    },
    inDays(d1, d2) {
      var t2 = d2.getTime();
      var t1 = d1.getTime();

      return parseInt((t2 - t1) / (24 * 3600 * 1000));
    },
    // Load list room
    loadListRoom(data) {
      this.listRoom = [];
      this.listRoom.push({
        value: -1,
        text: this.$t("ALL_ROOM"),
      });
      this.listRoom = this.listRoom.concat(
        data.map((room) => {
          return {
            value: room.id,
            text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n).name,
          };
        })
      );
    },
    changeSearchCondition() {
      this.getData();
    },
    nextMonth() {
      this.selectedDatePicker = moment(this.selectedDatePicker)
        .add(15, "day")
        .format("YYYY-MM-DD");
      this.getData();
    },
    prevMonth() {
      this.selectedDatePicker = moment(this.selectedDatePicker)
        .add(-15, "day")
        .format("YYYY-MM-DD");

      if (this.selectedDatePicker < moment().startOf("day").format("YYYY-MM-DD")) {
        this.selectedDatePicker = moment().startOf("day").format("YYYY-MM-DD");
      }
      this.getData();
    },

    numberFormat(x) {
      if (x) {
        return new Intl.NumberFormat(this.defaultI18n, {
            style: 'decimal',
            minimumFractionDigits: this.usedCurrency == 'VND' ? 0 : 2,
            maximumFractionDigits: this.usedCurrency == 'VND' ? 0 : 2,
        }).format(x)
      }
    },
    priceFormat(val) {
      const value =
        Math.abs(val) > 999999 && Math.abs(val) < 1000000000
          ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(2)}M`
          : Math.abs(val) >= 1000000000
          ? `${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(2)}B`
          : Math.abs(val) === 0
          ? `0`
          : `${Math.sign(val) * (Math.abs(val) / 1000)}K`;
      return value;
    },
    editServiceRoomRate(roomPlan) {
      this.$router.push({
        name: "detail-room-rate-package",
        params: {
          id: roomPlan.id,
        },
      });
    },
    _moment: moment,
  },
};
</script>
<style lang="scss" scoped>
.special-price + div {
  display: none;
}

.add-person {
  padding-left: 10px;
  z-index: 99999999;
}

.delete-person {
  padding-left: 10px;
  z-index: 99999999;
}

.copy-price {
  left: -8px;
  top: 8px;
  position: absolute;
  z-index: 99999999;
}

.tab-header {
  background-color: #fff;
  padding: 25px 15px 10px 15px;
}

.restriction-ota {
  font-size: 14px;

  h6 {
    font-size: 14px;

    &.room-title {
      background: #f0f0f0;
      padding: 10px;
      margin: 0;
      border-radius: 5px;
    }
  }

  .sale-package-info {
    align-items: center;
    border-bottom: 1px solid #dedddd;
    padding-bottom: 5px;
  }

  .col-md-12:last-child {
    .sale-package-info {
      border-bottom: none;
    }
  }
}
</style>